// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file for a purchase order to the remote API.
 *
 * @param id - The ID of the purchase order for which to upload the file.
 * @param file - The file to upload.
 */
export async function uploadPurchaseOrderFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'PURCHASE_ORDER_FILE',
    isPublic: false,
    entityId: id,
  });
}
